export default __webpack_public_path__ + "static/media/sea.128c4a06.png";